<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import JsrydjBrowse from "./JsrydjBrowse";
import JsrydjEdit from "./JsrydjEdit";
import JsrydjForm from "./JsrydjForm";
export default {
    name: "jsrydj",
    components: { JsrydjBrowse, JsrydjEdit, JsrydjForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "JsrydjEdit";
            } else if (this.editProps.showForm === true) {
                return "JsrydjForm";
            } else {
                return "JsrydjBrowse";
            }
        }
    }
};
</script>
